import axios from 'axios';
import { SLACK_WEBHOOKS } from '../config';
import { FETCH_CURRENCY, FETCH_CURRENCY_FAIL, SAVE_CURRENCY, SET_CURRENCY } from './types';
import { SlackWebhook } from './utils';


/**
 * Fetch currency via Busabout API
 */
export function FetchCurrency() {

    const CURRENCY_URL  = process.env.REACT_APP_CURRENCY_API;

    return async dispatch => {
      try{
        const data = await axios.get(CURRENCY_URL);
        dispatch({type:FETCH_CURRENCY, payload:data});
        dispatch({type:SET_CURRENCY, payload:data});
      }
      catch(err){
        dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':"Discovery pages - CURRENCY API -  " + CURRENCY_URL + "" + err}));
        dispatch({type:FETCH_CURRENCY_FAIL});
        console.error(err);
      };
  }
}

/**
 * Save currency via Busabout API (Matrix)
 */
export function SaveCurrency(value){
  return dispatch => {
    dispatch({type:SAVE_CURRENCY, payload:value});
  }
}



// WEBPACK FOOTER //
// ./src/actions/currency.js